import { FC, useEffect } from 'react';
import { useData } from '@hooks/useData';
import { AppContainer } from '@components/organisms/AppContainer';
import { SpaceDetailContainer } from '@components/organisms/SpaceDetailContainer';
import { useParams } from 'react-router';
import { useGetSpaceDetail } from '@services/useGetSpaceDetail';
import { CtaBanner } from '@components/organisms/CtaBanner';
import { useGetBannerRegisterProperty } from '@services/useGetBannerRegisterProperty';
import { useCustomNavigate } from '@hooks/useCustomNavigate';
import { SITE_URLS } from '@constants';

export const SpaceDetail: FC = () => {
    const { uuid } = useParams<{ uuid: string }>();
    const { request, error, clearError } = useGetSpaceDetail();
    const { spaceDetail, isLoadingSpaceDetail } = useData();
    const { navigate } = useCustomNavigate();
    const { banner, request: fetchBanner, loading: bannerLoading } = useGetBannerRegisterProperty();

    useEffect(() => {
        clearError();
        if (uuid) {
            request(uuid);
        }
        fetchBanner();
        // eslint-disable-next-line
    }, [uuid]);

    useEffect(() => {
        // Redireciona apenas quando o erro for 404 (space nao encontrado)
        // Nao redireciona em caso de timeout ou outros erros de rede
        if (!isLoadingSpaceDetail && error?.isNotFound && uuid) {
            navigate(`/${SITE_URLS.pageNotFound}`, { replace: true });
        }
    }, [isLoadingSpaceDetail, error?.isNotFound, uuid, navigate]);

    const handleBannerClick = () => {
        if (banner?.content_banner_register_property_link) {
            navigate(banner.content_banner_register_property_link);
        }
    };

    const ctaBannerElement = !bannerLoading && banner ? (
        <CtaBanner
            variant="background"
            subtitle={banner.content_banner_register_property_subtitle}
            title={banner.content_banner_register_property_title || ''}
            description={banner.content_banner_register_property_description}
            buttonText={banner.content_banner_register_property_button_text}
            onButtonClick={handleBannerClick}
            imageUrl={banner.content_banner_register_property_image}
            imageAlt={banner.content_banner_register_property_title || 'Banner'}
        />
    ) : undefined;

    if (isLoadingSpaceDetail || !spaceDetail?.data) {
        return (
            <AppContainer>
                <SpaceDetailContainer space={null as any} loading={isLoadingSpaceDetail} />
            </AppContainer>
        );
    }

    return (
        <AppContainer ctaBanner={ctaBannerElement}>
            <SpaceDetailContainer space={spaceDetail?.data!} loading={isLoadingSpaceDetail} />
        </AppContainer>
    );
};
